//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdeInstitutPredpokladPlanDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-14                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvvtip) GID:(Web.Set.Des.Ts) V1:(ixs_pla,ixs_tip,priz_pov,priz_pov_ixb,aktivita,dat_zmena,zmenu_prov,priz_nevyzad) V2:() K1:() K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdeInstitutPredpokladPlanDesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamAdeInstitutPredpokladPlanDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - ixs_pla */
            public ixs_pla: string;
            /** PK - ixs_tip */
            public ixs_tip: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdeInstitutPredpokladPlanListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdeInstitutPredpokladPlanDesigner>, ixs_pla: string,ixs_tip: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, ixs_pla, ixs_tip);
            v_form.addRow("jres:33000146").addField("gselectbox", Gordic.Prefabs.Select.admSrvspla(), {
                dropdown: false,
                name: "ixs_pla",
                model: "model.ixs_pla=value.ixs_pla",
                initialValue: ixs_pla ? { ixs_pla: ixs_pla } : null,
                //graphicInput: "oninput",
                disabled: ixs_pla ? true : false,
            })
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction, {
                hardDefaultFilter: {
                    ixs_pla: ixs_pla,
                    ixs_tip: ixs_tip
                }
            });

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdeInstitutPredpokladPlanDesigner>, ixs_pla: string,ixs_tip: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdeInstitutPredpokladPlanDesigner>, ev, ctx): any {
            var filterObj = {
                ixs_pla: SeznamBase.filterContains(ctx.filter, "ixs_pla") 
            }
            that.view = new Gordic.Isl.View(that.isl.AdeInstitutPredpokladPlan.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdeInstitutPredpokladPlanDesignerInit
         * 
         * @param {GContentType<SeznamAdeInstitutPredpokladPlanDesigner>} that
         */
        static SeznamAdeInstitutPredpokladPlanDesignerInit(that: GContentType<SeznamAdeInstitutPredpokladPlanDesigner>, ixs_pla: string,ixs_tip: string ) {
            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, ixs_pla,ixs_tip);
            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);
            this.LoadData(that, ixs_pla, ixs_tip);

        } // SeznamAdeInstitutPredpokladPlanDesignerInit


        static LoadData(that: GContentType<SeznamAdeInstitutPredpokladPlanDesigner>, ixs_pla: string, ixs_tip: string) {
            var filterObj: any = {}
            if (ixs_pla) {
                new Gordic.Data.Readers.AdmSrvspla().getData({ ixs_pla: ixs_pla }).done((o) => {
                    that.filter.findFields("ixs_pla").gfield("setInitial", o[0]);
                })
                filterObj.ixs_pla = ixs_pla;
            }
            that.view = new Gordic.Isl.View(that.isl.AdeInstitutPredpokladPlan.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem
        }
    }
}
